module.exports = __webpack_public_path__ + "img/1791992011907.6661a909.png";